import React from 'react';
import List from './List';

const RejectedList = ({ ...props }) => (
  <List
    url="orders?order_status=rejected"
    title="Rejected Orders"
    canAssign={!props.readOnly}
    canManage={!props.readOnly}
    canView={true}
    {...props}
  />
);

export default RejectedList;



// WEBPACK FOOTER //
// ./src/pages/Orders/RejectedList.jsx